export default {
  methods: {
    $setFiltersFromQuery() {
      // const filtersObj = {};
      Object.entries(this.$route.query).forEach(([key, value]) => {
        if (key === "transactionTimeFrom" || key === "transactionTimeTo") {
          this.date.push(this.$renderDate(value));
        }
        if (
          key === "userId" ||
          key === "businessId" ||
          key === "businessTypeId" ||
          key === "page" ||
          key === "size" ||
          key === "currencyId"
        ) {
          this.filtersObj[key] = +value;
        } else this.filtersObj[key] = value;
      });
      // return filtersObj;
    },
    $setQueryFromFilters(paginationButton = false) {
      const queryObj = {};
      Object.entries(this.filtersObj).forEach(([key, value]) => {
        if (value) {
          queryObj[key] = value;
          // set to go on the first page when filtering gets submitted.
          if (key === "page" && !paginationButton) {
            queryObj[key] = 1;
            this.filtersObj[key] = 1;
          }
        }
      });
      if (this.date && this.date.length) {
        const d = new Date(this.date[0]);
        if (this.date.length > 1) {
          const d0 = new Date(this.date[0]);
          const d1 = new Date(this.date[1]);
          // queryObj.transactionTimeFrom = d0.getTime();
          queryObj.transactionTimeFrom = d0.setHours(0, 0, 0, 0);
          queryObj.transactionTimeTo = d1.setHours(23, 59, 59, 999);
        } else {
          queryObj.transactionTimeFrom = d.setHours(0, 0, 0, 0);
          // queryObj.transactionTimeFrom = d.getTime();
        }
      }
      this.$router.replace({ query: { ...queryObj } }, () => {});
      return queryObj;
    }
  }
};
